import { Star, Users, Globe, Clock, ThumbsUp, Repeat } from 'lucide-react';
import { trustIndicators } from '@/data/portfolio';
import { CountUp } from '@/components/ui/CountUp';
import { motion } from 'framer-motion';

const indicators = [
  {
    icon: Star,
    value: trustIndicators.projectsCompleted,
    label: "Projects Completed",
    color: "text-yellow-500"
  },
  {
    icon: ThumbsUp,
    value: trustIndicators.clientSatisfaction,
    label: "Client Satisfaction",
    color: "text-green-500"
  },
  {
    icon: Globe,
    value: trustIndicators.countriesServed,
    label: "Countries Served",
    color: "text-blue-500"
  },
  {
    icon: Clock,
    value: trustIndicators.yearsExperience,
    label: "Years Experience",
    color: "text-purple-500"
  },
  {
    icon: Users,
    value: trustIndicators.upworkSuccessRate,
    label: "Upwork Success",
    color: "text-green-600"
  },
  {
    icon: Repeat,
    value: trustIndicators.repeatClients,
    label: "Repeat Clients",
    color: "text-primary"
  },
];

export function TrustIndicators() {
  return (
    <section className="py-16 bg-gradient-to-r from-primary/5 via-background to-primary/5">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ staggerChildren: 0.1, delayChildren: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6"
        >
          {indicators.map((indicator, index) => (
            <motion.div
              key={indicator.label}
              initial={{ y: 30, opacity: 0, scale: 0.9 }}
              whileInView={{ y: 0, opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ type: "spring", stiffness: 100, damping: 15, delay: index * 0.1 }}
              className="text-center p-6 rounded-xl bg-background border border-border/50 
                        hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5 
                        transition-all duration-300"
            >
              <indicator.icon className={`w-8 h-8 mx-auto mb-3 ${indicator.color}`} />
              <div className="text-3xl font-bold text-foreground mb-1">
                <CountUp to={indicator.value} duration={2.5} delay={0.3} className="inline-block" />
              </div>
              <div className="text-sm text-muted-foreground">{indicator.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
